module.exports = __webpack_public_path__ + "img/btnCard-1.ae72c145.jpg";